import React from 'react';
import { compose } from 'redux';
import { ScreenName } from '@helpcenter/constants';
import { useIntl } from 'react-intl';
import { withOnlyJiraAdmin } from 'view/common/with-only-jira-admin';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { getJiraDisplayUrl } from '@atlassian/help-center-common-util/env';
import { replace } from '@atlassian/help-center-common-util/location';
import {
	HelpCentersManagementPage,
	HelpCentersManagementResource,
	MigrationCandidatesResource,
	authPageMessage,
	callToActionUrlText,
} from '@atlassian/help-centers-management';

const JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT = 'jira_sidebar_show_helpcenter';

const isJiraSidebarShowHelpcenterExperimentEnabled = (): boolean =>
	FeatureGates.getExperimentValue(JIRA_SIDEBAR_SHOW_HELPCENTER_EXPERIMENT, 'isEnabled', false);

const JiraHelpCenterManagementRedirect = () => {
	React.useEffect(() => {
		replace(`${getJiraDisplayUrl()}/jira/helpcenter-management${window.location.search}`);
	}, []);

	return null;
};

const HelpCentersManagement = () => {
	const { formatMessage } = useIntl();
	const WrappedComponent = React.useMemo(
		() =>
			compose(
				withOnlyLoggedIn({ redirectUrl: '/' }),
				withOnlyJiraAdmin({
					message: formatMessage(authPageMessage),
					callToActionText: formatMessage(callToActionUrlText),
					callToActionUrl: '',
				}),
			)(HelpCentersManagementPage),
		[formatMessage],
	);
	return <WrappedComponent />;
};

const HelpHubsManagement = () => {
	const { formatMessage } = useIntl();
	const WrappedComponent = React.useMemo(
		() =>
			compose(
				withOnlyLoggedIn({ redirectUrl: '/' }),
				withOnlyJiraAdmin({
					message: formatMessage(authPageMessage),
					callToActionText: formatMessage(callToActionUrlText),
					callToActionUrl: '',
				}),
			)(HelpCentersManagementPage),
		[formatMessage],
	);

	if (isJiraSidebarShowHelpcenterExperimentEnabled()) {
		return <JiraHelpCenterManagementRedirect />;
	}

	return <WrappedComponent />;
};
export const viewHelpCentersManagementPageRoute = {
	name: ScreenName.HELP_CENTERS_MANAGEMENT,
	path: '/',
	exact: true,
	component: HelpCentersManagement,
	resources: [HelpCentersManagementResource, MigrationCandidatesResource],
};

export const viewHelpHubsManagementPageRoute = {
	name: ScreenName.HELP_HUBS_MANAGEMENT,
	path: '/hubs',
	exact: true,
	component: HelpHubsManagement,
	resources: [HelpCentersManagementResource],
};
